import React from 'react';

export interface ColorSampleBlockProps {
  /** CSS color token from variable (e.g. hex, rgb). */
  colorToken: string;
  className?: string;
}

/**
 * Read-only solid color block for rich text (e.g. after a `<Color-Picker>` choice).
 * Uses a neutral black border (not the adventure option frame) since it is not selectable.
 */
const ColorSampleBlock: React.FC<ColorSampleBlockProps> = ({ colorToken, className = '' }) => {
  const trimmed = colorToken.trim();

  const inner = !trimmed ? (
    <div
      className="rich-text-color-sample rich-text-color-sample--empty"
      role="presentation"
      aria-hidden
    />
  ) : (
    <div
      className="rich-text-color-sample"
      style={{ backgroundColor: trimmed }}
      role="img"
      aria-label={`Color sample ${trimmed}`}
    />
  );

  return (
    <div className={`rich-text-color-sample-wrap ${className}`.trim()}>
      {inner}
    </div>
  );
};

export default ColorSampleBlock;
